export default "__VITE_ASSET__DCKtfwmg__"